export default __webpack_public_path__ + "static/media/back-arrow-small.cf1481db.svg";